import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { IApiResponse } from "../../../AbstractApiClient/IApiResponse";

export const updateUserCard = (axios: IAxiosInstance) => {
  return async (params: {
    userID: string;
    cardID: string;
    lastFour: string;
    cardCompany: string;
    expDate: string;
    firstName: string;
    lastName: string;
  }) => {
    const response = await axios.noRetry.patch<IApiResponse<any>>(
      `/push-to-card/card`,
      {
        userID: params.userID,
        cardID: params.cardID,
        lastFour: params.lastFour,
        cardCompany: params.cardCompany,
        expDate: params.expDate,
        firstName: params.firstName,
        lastName: params.lastName,
      }
    );

    return response.data;
  };
};
